import { addPrefetch, canUseWebP, getRoundedDimensions, allowStatCookies } from '../utils/helpers';
import { scrollTo } from '../utils/scrollTo';

class Video {
    constructor(container) {
        this.container = container;
        this.id = container.getAttribute('data-video-id');
        this.bg = container.getAttribute('data-video-bg') || 0;
        this.byline = container.getAttribute('data-video-byline') || 0;
        this.color = container.getAttribute('data-video-color') || 0;
        this.controls = container.getAttribute('data-video-controls') || 1;
        this.ytUrl = allowStatCookies ? 'https://www.youtube.com' : 'https://www.youtube-nocookie.com';

        if (!this.id) {
            this.videoLink = container.getAttribute('data-video-link');
            if (this.videoLink) {
                this.id = extractVideoIdFromUrl(this.videoLink);
            } else {
                console.warn('Video missing video-id / data-video-link');
                return;
            }

            if (this.id.indexOf('/') > -1) {
                this.id = this.id.slice(0, this.id.indexOf('/'));
                this.isPrivate = true;
            }
        }

        this.isVimeo = container.getAttribute('data-action') === 'video-vimeo' || this.videoLink && this.videoLink.indexOf('vimeo') > -1;
        this.poster = container.getAttribute('data-poster') || container.getAttribute('data-src');

        if (!this.poster) {
            if (this.isVimeo) {
                if (this.isPrivate) {
                    this.container.classList.add('placeholder');
                } else {
                    let { width, height } = getRoundedDimensions(container.getBoundingClientRect());
                    const devicePixelRatio = window.devicePixelRatio || 1;
                    width *= devicePixelRatio;
                    height *= devicePixelRatio;

                    this.poster = `https://lite-vimeo-embed.now.sh/thumb/${this.id}`;
                    this.poster += `.${canUseWebP() ? 'webp' : 'jpg'}`;
                    this.poster += `?mw=${width}&mh=${height}&q=${devicePixelRatio > 1 ? 70 : 85}`;
                }

            } else {
                this.poster = `https://i.ytimg.com/vi/${this.id}/sddefault.jpg`;
            }
        }

        if (this.poster && !this.container.classList.contains('lazy')) {
            this.container.style.backgroundImage = `url("${this.poster}")`;
        }

        this.container.addEventListener('pointerover', Video.warmConnections, { once: true });
        this.container.addEventListener('click', () => this.addIframe());
    }

    static warmConnections() {
        if (Video.preconnected) return;

        if (this.isVimeo) {
            addPrefetch('preconnect', 'https://player.vimeo.com');
            addPrefetch('preconnect', 'https://i.vimeocdn.com');
            addPrefetch('preconnect', 'https://f.vimeocdn.com');
            addPrefetch('preconnect', 'https://fresnel.vimeocdn.com');
        } else {
            addPrefetch('preconnect', this.ytUrl);
            addPrefetch('preconnect', 'https://www.google.com');
            addPrefetch('preconnect', 'https://googleads.g.doubleclick.net');
            addPrefetch('preconnect', 'https://static.doubleclick.net');
        }

        Video.preconnected = true;
    }

    addIframe() {
        const videoService = this.isVimeo ? 'https://player.vimeo.com/video' : `${this.ytUrl}/embed`;
        let videoUrl = `${videoService}/${this.id}?autoplay=1&rel=0`;
        const iframe = document.createElement('iframe');
        iframe.setAttribute('frameborder', 0);
        iframe.setAttribute('allowtransparency', 'true');
        iframe.setAttribute('playsinline', 'true');
        iframe.setAttribute('tabindex', '-1');
        iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; autoplay');
        iframe.addEventListener('load', () => {
            setTimeout(() => {
                this.container.classList.add('video--loaded');
                this.container.classList.remove('loading');

                if (this.container.getAttribute('data-scroll-to')) {
                    scrollTo(this.container, 1000);
                }
            }, 300);
        });

        videoUrl += `&controls=${this.controls}&byline=${this.byline}&background=${this.bg}&mute=${this.bg}`;
        if (this.color) videoUrl += `&color=${this.color}`;

        iframe.src = videoUrl;

        this.container.classList.add('loading');
        this.container.appendChild(iframe);
    }
}


function extractVideoIdFromUrl(url) {
    const videoIdRegExp = /^.*((youtu.be\/|vimeo.com\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url.match(videoIdRegExp);

    if (match && match[7]) {
        return match[7];
    } else {
        console.warn(url, 'Invalid Video URL');
    }
}

export function setupVideos(selector = '[data-action^="video"]') {
    const videos = document.body.querySelectorAll(selector);

    for (let i = 0; i < videos.length; i++) {
        void new Video(videos[i]);
    }
}
